var message_1 = require("./message");
/**
 * Creates a new HL7 message. If the message text is not specified, an empty HL7 message is created.
 * @param text Optional. The text to parse.
 */
function create(text) {
    return new message_1.default(text);
}
exports.create = create;
